"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SORT_DIRECTION = exports.DEFAULT_DIRECTION = exports.DEFAULT_DESELECTABLE = void 0;
const constant_1 = require("../constant");
const library_1 = require("library");
exports.DEFAULT_DESELECTABLE = true;
exports.DEFAULT_DIRECTION = constant_1.HorizontalDirection.Right;
exports.DEFAULT_SORT_DIRECTION = library_1.SortDirection.Ascend;
